export enum MboInstitutionPermissions {
  MboInstitution = 'mbo-institution',
}
